import commonActions from './common';
import mavlinkActions from './mavlink';

// 프로토콜별 namespaces
export const mavlink = mavlinkActions;

// 하위 호환성을 위해 default export도 제공
const missionActions = {
  ...commonActions,
  mavlink: mavlinkActions,
};

export default missionActions;
